export default __webpack_public_path__ + "static/illustration-action.url-dfc85af653babef8b97579ed7d5133c9.svg";